import React from 'react';
import { Field } from 'react-final-form';
import { NoteDisclosure, validations } from '@unite-us/app-components';
import { TextField } from '@unite-us/ui';

const NoteField = () => (
  <Field name="note">
    {(params) => (
      <TextField
        id="noteInput"
        label="Note"
        afterLabelContent={<NoteDisclosure isClosingCase />}
        required
        {...params}
        validations={validations.isRequired}
      />
    )}
  </Field>
);

export default NoteField;
